import styled, { css } from 'styled-components';
import { default as ArrowIcon } from 'components/icons/DropdownArrow';
import {
	black,
	chartPptBarBlue,
	chartPptBlack,
	grey200,
	grey100,
} from 'styles/colors';
import { BarChartProgressBackground } from '../SpendCategorizationChart/styles';
import { Wrapper as ContextualWrapper } from '../ContextualMenu/ContextualMenu.styles';

export const TableContainer = styled.table`
	position: relative;
	font-family: Roboto;
	width: 100%;
	border: none;
`;

export const TableCell = styled.td`
	text-align: right;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 19px;
	padding: 0 0 0 8px;
	position: relative;

	&:first-child {
		font-weight: normal;
	}
`;

export const TotalBarListWrapper = styled.div`
	margin-bottom: 8px;
`;

export const TotalBarTableProgress = styled.td`
	padding-bottom: 8px;
`;

export const TableCellValue = styled(TableCell)`
	text-transform: uppercase;
	min-width: 100px;
`;

export const TableHeaderItem = styled.td`
	font-size: 19px;
	font-weight: 500;
	line-height: 27px;
	text-align: right;
	color: ${black};
	vertical-align: bottom;
	padding: 0;

	& + & {
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 0.3;
	}

	&:not(:first-child) {
		padding-left: 20px;
		width: 10%;
	}
`;

export const TableRow = styled.tr`
	transition: 0.3s;
	color: ${black};
	font-size: 13px;
	height: 25px;
	vertical-align: bottom;

	${ContextualWrapper} {
		display: none;
		left: -36px;
		top: -2px;
	}

	${({ active }) =>
		active &&
		css`
			${ContextualWrapper} {
				display: block;
			}
		`};

	${({ hasOnClick }) =>
		hasOnClick &&
		css`
			&:hover {
				${ContextualWrapper} {
					display: block;
				}
			}
		`};

	& ${TableHeaderItem}:first-child {
		text-align: left;
	}

	& ${TableCell}:first-child {
		text-align: left;
	}

	&:nth-child(3) {
		letter-spacing: initial;
		vertical-align: bottom;
		height: 30px;
	}
`;

export const TableHeader = styled(TableRow)`
	color: ${black};
	font-size: 11px;
	line-height: 25px;
	text-align: right;
	vertical-align: top;

	& + & {
		${TableCell} {
			font-weight: normal;
		}
	}

	& ${TableCell} {
		font-weight: 100;
	}

	& ${TableCell}:first-child {
		text-align: left;
		color: ${black};
		font-size: 19px;
		font-weight: 500;
		line-height: 25px;
		padding-right: 40px;
	}
`;

export const ListContainer = styled.ul`
	position: relative;
	margin-top: 32px;
	flex-grow: 1;
	flex-basis: 0;
`;

export const SecondaryListContainer = styled.div`
	display: flex;
	flex-flow: row;

	& > div {
		flex: 1;
		margin: 0;
		${({ isPptExport }) =>
			!isPptExport
				? css`
						padding-right: 25px;
						max-width: 50%;
				  `
				: css`
						${DropdownWrapper} svg {
							visibility: hidden;
						}
				  `};
	}

	& > div:last-child {
		padding-left: 25px;
		padding-right: 0;
	}
`;

export const ListCell = styled.span`
	text-align: right;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	letter-spacing: 0.3px;
	align-self: flex-end;
	line-height: 20px;
	flex: 1;

	& + & {
		text-align: right;
		overflow: visible;
		height: 20px;

		span {
			padding-left: 10px;
		}
	}
`;

export const ListCellValue = styled(ListCell)`
	text-transform: uppercase;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	font-weight: 500;
`;

export const ListCellValueItem = styled.div`
	min-width: 90px;
	text-align: right;

	&:not(:first-child) {
		margin-left: 20px;
	}
`;

export const ListItem = styled.li`
	transition: 0.3s;
	color: ${black};
	font-size: 13px;
	letter-spacing: 0.8px;
	height: 22px;
	display: flex;
	position: relative;

	${ContextualWrapper} {
		display: none;
		left: -36px;
		top: -6px;
	}

	${({ active }) =>
		active &&
		css`
			${ContextualWrapper} {
				display: block;
			}
		`};

	${({ hasClick }) =>
		hasClick &&
		css`
			&:hover {
				${ContextualWrapper} {
					display: block;
				}
			}
		`};

	& ${ListCell}:first-child {
		text-align: left;
	}
`;

export const ChartRow = styled.li`
	margin-bottom: 5px;
`;

export const ListHeader = styled(ListItem)`
	font-size: 19px;
	font-weight: 500;
	text-align: right;
	display: flex;
	color: ${black};
	height: 35px;
	line-height: 35px;
	vertical-align: top;
	letter-spacing: 0;
	margin-bottom: 3px;

	& ${ListCell} {
		margin-top: 0;

		&:last-child {
			font-size: 16px;
			font-weight: bold;
			letter-spacing: 0.3;
		}
	}

	& > ${ListCell} {
		padding-bottom: 23px;

		&:first-child {
			padding-bottom: 0;
		}
	}
`;

export const ListHeaderTitles = styled(ListHeader)`
	margin-bottom: 0;
	height: 26px;

	${ListCellValueItem} {
		font-size: 11px;
		letter-spacing: 0;
		line-height: 13px;
	}
	& ${ListCell} {
		&:last-child {
			margin-top: 6px;
			text-transform: none;
			font-weight: 100;
		}
	}
`;

export const ShowMoreWrapper = styled.div`
	margin-left: 16px;
`;

export const RowsCountDataContainer = styled.div`
	align-items: center;
	display: flex;
	color: #737373;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.8px;
	line-height: 19px;
	text-align: right;
`;

export const MoreLessBlockWrapper = styled.div`
	display: flex;
	margin-top: 7px;
`;

export const ListContainerWithExport = styled(ListContainer)`
	${BarChartProgressBackground} {
		background-color: ${grey100};
	}
`;

export const TableContainerWithExport = styled(TableContainer)`
	${BarChartProgressBackground} {
		background-color: ${grey100};
	}
`;

export const ExportWidthContainer = styled.div`
	background: ${({ id }) => (id ? 'white' : 'transparent')};
	padding-top: 8px;
	width: ${({ width }) => (width ? `${width}px` : 'auto')};
	height: ${({ height }) => (height ? `${height}px` : 'auto')};
	margin-top: ${({ id }) => (id ? 0 : '30px')};
	padding-bottom: 0;

	${MoreLessBlockWrapper} {
		display: ${({ id }) => (id ? `none` : 'flex')};
	}
`;

export const PPTExportContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 15px;

	${TableRow} {
		${TableCell} {
			letter-spacing: 0.8px;
		}
	}

	${ListCell} {
		letter-spacing: 0.8px;
	}

	${TableHeader} {
		${TableCell} {
			letter-spacing: 0.3px;
		}
	}

	td,
	li {
		color: ${chartPptBlack};
		font-family: 'Verdana';
	}

	tr {
		border-color: ${chartPptBarBlue};
	}

	table {
		margin-bottom: 55px;
	}

	${SecondaryListContainer} {
		display: block;

		> div {
			padding-left: 0;
		}
	}

	${ListCell}, ${ListCellValue} {
		color: ${chartPptBlack};
	}

	${ListHeaderTitles} {
		${ListCellValueItem} {
			color: ${chartPptBlack};
			letter-spacing: 0.3px;
		}
	}

	${TableHeader} ${TableCell}:first-child {
		font-size: 21px;
	}
`;

export const Arrow = styled(ArrowIcon)`
	flex: 0 0 auto;
	margin-left: 8px;
	width: 11px;
	height: 6px;
	color: ${props => (props.open ? 'inherit' : grey200)};
	transition: 100ms ease-in-out;
	transition-property: transform, color;
	transform: ${props => !props.open && 'rotate(180deg)'};
`;

export const DropdownWrapper = styled.span`
	button:first-child {
		display: inline-flex;
		padding-left: 0;
		padding-top: 0px;
		height: 32px;
		max-width: 100%;

		span:first-child {
			font-size: 19px;
			text-transform: initial;
			width: calc(100% - 17px);
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			padding-top: 8px;
			color: ${black};

			& ~ svg {
				margin-top: 10px;
			}

			&:first-letter {
				text-transform: uppercase;
			}
		}
	}
`;
